import { lazy } from 'react'
import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'

const KnowledgeBasePage = lazy(() => import('./pages/KnowledgeBasePage'))

const routes: AppRoute[] = [
  {
    path: 'knowledge-base',
    element: KnowledgeBasePage,
    meta: {
      title: 'knowledgeBase.title',
      require: { minRole: ROLE.MEMBER },
    },
  },
]

export default routes
